import { Chip, Tooltip } from "@material-ui/core";
import { useState } from "react";
import { AutocompleteArrayInput, Identifier } from "react-admin";

type Props = React.ComponentProps<typeof AutocompleteArrayInput>;

export const CompactAutocompleteArrayInput = (props: Props) => {
  const [expanded, setExpanded] = useState(false);
  const { input, choices = [], optionText = "label", optionValue = "id", options } = props;
  const selectedIds: Identifier[] = Array.isArray(input?.value) ? input!.value : [];
  const selected = selectedIds.map(id => (choices as any[]).find(choice => String(choice[optionValue]) === String(id)))
    .filter(Boolean);
  const label = (choice: any) => typeof optionText === "function" ? optionText(choice) : choice[optionText as string];
  const hidden = selected.slice(2);

  return (
    <AutocompleteArrayInput
      {...props}
      options={{
        ...options,
        InputProps: {
          ...options?.InputProps,
          startAdornment: (
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 4 }}>
              {(expanded ? selected : selected.slice(0, 2)).map(choice => (
                <Chip
                  key={choice[optionValue]}
                  label={label(choice)}
                  size="small"
                  style={{ maxWidth: 150 }}
                  onDelete={props.disabled ? undefined : () => input!.onChange(
                    selectedIds.filter(id => String(id) !== String(choice[optionValue]))
                  )}
                />
              ))}
              {hidden.length > 0 && (
                <Tooltip title={hidden.map(label).join(", ")}>
                  <Chip
                    label={expanded ? "Riduci" : `+${hidden.length}`}
                    size="small"
                    onClick={() => setExpanded(!expanded)}
                    aria-label={expanded ? "Mostra solo due selezioni" : "Mostra tutte le selezioni"}
                  />
                </Tooltip>
              )}
            </div>
          ),
        },
      }}
    />
  );
};
